import FormatFunction from "../Fn";

/**
 * 부가세 합한 금액 구하기
 * @param price 원가
 * @param tax 부가세
 * @param amount 수량
 * @returns
 */
export function sumPrice(
  price: number | undefined,
  tax?: number | undefined,
  amount?: number | undefined
) {
  const sum = (price || 0) + (tax || 0);
  const amt = amount === undefined ? 1 : amount;

  return function format(trans = false) {
    const price = sum * amt;

    return trans ? FormatFunction.numFormat(price) : sum * amt;
  };
}

/**
 * 금액 환산
 * @param price
 * @returns
 */
export const formatPrice = (price: number | undefined) => {
  return price ? FormatFunction.numFormat(price) : undefined;
};
